import Factory from '../factory';

const schema = Factory.schema('audio');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('title').setType(String);
attributes.prop('src').setType(String);

export default schema;
